<template>
    <div class="main-container">
        <HeaderElement />
        <div class="shop bg-gray">
            <h1 class="shop__title">Alle MHP-Finance Pakete</h1>
            <div class="shop__slider">
                <div class="shop__items" ref="scrollContainer">
                    <router-link v-for="(item, key) in products" :key="key"
                        :to="{ name: 'ShopProduct', params: { package: item.package } }" class="shop__item">
                        <img class="shop__item-img" :src="item.img" />
                        <div class="shop__item-title">
                            {{ item.title }}
                        </div>
                    </router-link>
                </div>
            </div>
            <div class="shop__controls">
                <button class="shop__arrow shop__arrow--left" @click="scrollLeft">
                    <img src="../assets/img/icons/chevron-left.svg" />
                </button>

                <button class="shop__arrow shop__arrow--right" @click="scrollRight">
                    <img src="../assets/img/icons/chevron-right.svg" />
                </button>
            </div>
        </div>

        <FooterMain />
        <OffCanvasMobileMenu />
    </div>
</template>

<script>
import HeaderElement from '@/components/HeaderElement'
import FooterMain from '@/components/FooterMain'
import OffCanvasMobileMenu from '@/components/OffCanvasMobileMenu'

export default {
    name: 'Shop',
    components: {
        HeaderElement,
        FooterMain,
        OffCanvasMobileMenu
    },
    data() {
        return {
            scrollAmount: 400,
            products: null,
        }
    },
    methods: {
        updateScrollAmount() {
            const screenWidth = window.innerWidth;
            this.scrollAmount = screenWidth >= 1600 ? 800 : 600;
        },
        scrollLeft() {
            this.$refs.scrollContainer.scrollBy({
                left: -this.scrollAmount,
                behavior: 'smooth'
            });
        },
        scrollRight() {
            this.$refs.scrollContainer.scrollBy({
                left: this.scrollAmount,
                behavior: 'smooth'
            });
        }
    },
    async mounted() {
        try {
            const response = await fetch('/products.json');
            if (!response.ok) throw new Error('Fehler beim Laden der Produktdaten');
            this.products = await response.json();
        } catch (error) {
            console.error('Fehler beim Laden der products.json:', error);
        }

        this.updateScrollAmount();
        window.addEventListener('resize', this.updateScrollAmount);

    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateScrollAmount);
    },
}
</script>

<style lang="scss">
@use '../assets/scss/_variabls' as vars;

.shop {
    margin-top: 8rem;
    padding: 4rem 0;
    display: flex;
    flex-direction: column;
    text-align: center;

    &__title {
        margin: 0 1rem 2rem;
    }

    &__items {
        display: flex;
        gap: 2rem;
        width: 100%;
        flex-wrap: nowrap;
        overflow-x: auto;
        overflow-y: hidden;
        padding-left: 1rem;
        padding-right: 1rem;
        scroll-snap-type: x mandatory;
        scroll-padding-left: 1rem;
        -webkit-overflow-scrolling: touch;
        scroll-behavior: smooth;
    }

    &__item {
        display: flex;
        flex-direction: column;
        width: 400px;
        scroll-snap-align: start;

        &-img {
            height: 400px;
            border-top-left-radius: .5rem;
            border-top-right-radius: .5rem;
        }

        &-title {
            cursor: pointer;
            border-bottom-left-radius: .5rem;
            border-bottom-right-radius: .5rem;
            height: 4rem;
            background: vars.$theme-color--default-light;
            display: flex;
            justify-content: center;
            align-items: center;
            color: vars.$white;
            font-weight: 200;
            font-size: 1.2rem;
        }
    }

    &__controls {
        margin-top: 2rem;
        display: flex;
        gap: 1rem;
        justify-content: center;
    }

    &__arrow {
        width: 3rem;
        height: 3rem;
        border-radius: 100%;
        border: none;
        color: vars.$black;
        display: flex;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background: vars.$theme-color--default-light;
        transition: all 0.3s ease;
        border: 2px solid vars.$theme-color--default-light;

        &>img {
            height: 1.5rem;
        }

        &--left {
            left: 0;
        }

        &--right {
            right: 0;
        }
    }
}

@media #{vars.$laptop-up} {
    .shop {
        &__items {
            padding-left: 2rem;
            scroll-padding-left: 2rem;
        }
    }
}

@media #{vars.$xlmax-up} {
    .shop {
        &__slider {
            position: relative;
        }

        &__controls {
            display: none;
        }

        &__arrow {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);

            &:hover {
                border: 2px solid vars.$theme-color--default;
            }

            &--left {
                left: 0;
                margin-left: 20%;
            }

            &--right {
                right: 0;
                margin-right: 20%;
            }
        }

        &__items {
            width: 100%;
            margin: 0 auto;
            padding-left: 2rem;
            scroll-padding-left: 2rem;
        }
    }
}
</style>